import { Handle, Position } from 'reactflow';
import { Card } from '@/components/ui/card';
import { Mail, Settings, Sparkles, CheckCircle2, AlertCircle } from 'lucide-react';

export default function EmailContentNode({ data }: any) {
  const subject: string | undefined = data.emailSubject?.trim();
  const emailName: string | undefined = data.selectedEmailName?.trim();
  const hasInlineHtml = !!(data.emailHtml?.trim());
  const hasLibraryRef = typeof data.emailId === 'number';
  const hasAnyContent = hasInlineHtml || hasLibraryRef;
  const isConfigured = !!subject && hasAnyContent;
  const sourceLabel = hasInlineHtml ? 'Rascunho inline' : hasLibraryRef ? 'Biblioteca' : null;

  return (
    <Card
      className={
        'w-[260px] shadow-sm border ' +
        (isConfigured
          ? 'bg-blue-50 border-blue-300'
          : (subject || hasAnyContent)
            ? 'bg-amber-50 border-amber-300'
            : 'bg-rose-50 border-rose-300')
      }
    >
      <Handle type="target" position={Position.Left} className="!w-3 !h-3 !bg-blue-400 !border-blue-600" />
      <div className="p-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-blue-900">
          <Mail className="w-4 h-4 shrink-0" />
          <span className="truncate flex-1">{data.label || 'Enviar E-mail'}</span>
          {isConfigured ? (
            <CheckCircle2 className="w-3.5 h-3.5 text-emerald-600 shrink-0" />
          ) : (subject || hasAnyContent) ? (
            <AlertCircle className="w-3.5 h-3.5 text-amber-600 shrink-0" />
          ) : (
            <Settings className="w-3.5 h-3.5 text-rose-500 shrink-0" />
          )}
        </div>

        {subject || hasAnyContent ? (
          <div className="mt-2 space-y-1.5">
            {subject && (
              <div className="text-xs text-blue-700 bg-white/60 rounded px-2 py-1.5">
                <span className="text-blue-500 text-[10px] font-medium block">Assunto</span>
                <span className="break-words">{subject.length > 60 ? subject.slice(0, 60) + '…' : subject}</span>
              </div>
            )}
            {emailName && hasLibraryRef && (
              <div className="text-xs text-blue-700 bg-white/60 rounded px-2 py-1.5">
                <span className="text-blue-500 text-[10px] font-medium block">Biblioteca</span>
                <span className="truncate block">{emailName}</span>
              </div>
            )}
            {sourceLabel && (
              <div className="flex items-center gap-1 text-[10px] text-blue-600">
                <Sparkles className="w-2.5 h-2.5" />
                <span>{sourceLabel}</span>
              </div>
            )}
          </div>
        ) : (
          <div className="mt-2 flex items-center gap-1.5 text-xs text-rose-500 italic">
            <Settings className="w-3 h-3" />
            Clique para configurar
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Right} className="!w-3 !h-3 !bg-blue-400 !border-blue-600" />
    </Card>
  );
}
